import React from 'react';

const MasonryGallery = ({ images, onImageClick }) => {
  return (
    <div
      style={{
        columnCount: 3,
        columnGap: '24px',
        animation: 'fadeIn 0.5s ease-in'
      }}
      className="gallery-masonry"
    >
      {images.map((image, index) => (
        <div
          key={image.id}
          onClick={() => onImageClick(index, images)}
          style={{
            breakInside: 'avoid',
            marginBottom: '24px',
            overflow: 'hidden',
            cursor: 'pointer'
          }}
        >
          <img
            src={image.url}
            alt={`Gallery ${image.id}`}
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
              transition: 'transform 0.5s cubic-bezier(.645,.045,.355,1)'
            }}
            onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
          />
        </div>
      ))}
    </div>
  );
};

export default MasonryGallery;
